var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { WidgetType } from '../Model/WidgetType';
import { RatePlanWidgetContent } from '../Widget/RatePlanWidget/RatePlanWidgetContent';
import { AppearanceFactory } from './AppearanceFactory';
import { TriggerFactory } from './TriggerFactory';
import { ConditionFactory } from './ConditionFactory';
import { Widget } from '../Widget/Widget';
import { WidgetHostResolver } from '../Resolver/WidgetHostResolver';
import { SliderWidgetContent } from '../Widget/SliderWidget/SliderWidgetContent';
import { AppearanceType } from '../Model/AppearanceType';
var WidgetFactory = /** @class */ (function () {
    function WidgetFactory() {
    }
    WidgetFactory.build = function (model, behavior, hosts, language, group) {
        switch (model.type) {
            // HYPONLINE-91
            case WidgetType.Comparer:
                var comparerModel = model;
                return new Widget(AppearanceFactory.build(__assign(__assign({}, behavior.appearance), { type: AppearanceType.Comparer })), TriggerFactory.build(model, behavior.trigger), ConditionFactory.build(comparerModel.behavior.conditions), new RatePlanWidgetContent(comparerModel, WidgetHostResolver.resolve(hosts, group, language)));
            case WidgetType.RatePlan:
            case WidgetType.Cashback:
                var widgetModel = model;
                return new Widget(AppearanceFactory.build(__assign(__assign({}, behavior.appearance), { type: model.appearanceType })), TriggerFactory.build(model, behavior.trigger), ConditionFactory.build(widgetModel.behavior.conditions), new RatePlanWidgetContent(widgetModel, WidgetHostResolver.resolve(hosts, group, language), model.type));
            case WidgetType.Slider:
                var sliderModel = model;
                return new Widget(AppearanceFactory.build(__assign(__assign({}, behavior.appearance), { type: AppearanceType.Slider })), TriggerFactory.build(model, behavior.trigger), null, new SliderWidgetContent(sliderModel, behavior));
            case WidgetType.Button:
                var buttonModel = model;
                return new Widget(AppearanceFactory.build(__assign(__assign({}, behavior.appearance), { type: AppearanceType.Button })), TriggerFactory.build(model, behavior.trigger), null, new SliderWidgetContent(buttonModel, behavior));
            default:
                return null;
        }
    };
    return WidgetFactory;
}());
export { WidgetFactory };
